import { __extends } from "tslib";
import React from 'react';
import ChatroomListEntry from './ChatroomListEntry';
import style from './ChatroomList.scss';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import _findIndex from 'lodash/findIndex';
import { withChatrooms } from '../withChatrooms/withChatrooms';
import AnimatedPlaceholderChatroomList from '../AnimatedPlaceholder/AnimatedPlaceholderChatroomList';
import withSounds from '../../providers/withSounds/withSounds';
import { chatSdk } from '@wix/chat-sdk';
import AppModeProvider from '../../providers/appMode/AppModeProvider';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';
import _xor from 'lodash/xor';
import { Experiments } from '../../constants/experiments';
var ChatroomList = /** @class */ (function (_super) {
    __extends(ChatroomList, _super);
    function ChatroomList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectRoomIfNeeded = function (prevChatrooms) {
            var chatrooms = _this.props.chatrooms;
            if (_this.isNotFetchingRooms() &&
                _this.isChatroomRemovedFromCurrentList(prevChatrooms, chatrooms)) {
                _this.selectNextOrLastRoom(prevChatrooms);
            }
        };
        _this.isChatroomRemovedFromCurrentList = function (prevChatrooms, currentChatrooms) {
            return (_this.isSelectedRoomOnList(prevChatrooms) &&
                !_this.isSelectedRoomOnList(currentChatrooms));
        };
        _this.isNotFetchingRooms = function () { return !_this.props.isFetchingChatrooms; };
        _this.chatroomSelectHandler = function (id) {
            var onSelect = _this.props.onSelect;
            onSelect && onSelect(id);
        };
        _this.chatroomCheckHandler = function (id) {
            var _a = _this.props, onChatroomsCheck = _a.onChatroomsCheck, _b = _a.checkedChatrooms, checkedChatrooms = _b === void 0 ? [] : _b;
            onChatroomsCheck && onChatroomsCheck(_xor(checkedChatrooms, [id]));
        };
        _this.chatroomClickHandler = function (id) {
            var isNewBulkActionFTon = chatSdk.isExperimentOn(Experiments.NewBulkActions);
            var editMode = _this.props.editMode;
            if (editMode && !isNewBulkActionFTon) {
                _this.chatroomCheckHandler(id);
            }
            else {
                _this.chatroomSelectHandler(id);
            }
        };
        _this.isSelectedRoomOnList = function (rooms) {
            return _find(rooms, function (room) { return room.id === _this.props.selectedChatroomId; });
        };
        _this.selectFirstRoom = function () {
            return _this.chatroomSelectHandler(_this.props.chatrooms[0].id);
        };
        _this.selectNextOrLastRoom = function (prevChatrooms) {
            var _a = _this.props, chatrooms = _a.chatrooms, selectedChatroomId = _a.selectedChatroomId;
            var chatroomIndex = _findIndex(prevChatrooms, function (room) { return room.id === selectedChatroomId; });
            var nearestRightBrother = prevChatrooms
                .slice(chatroomIndex + 1)
                .find(function (_a) {
                var id1 = _a.id;
                return chatrooms.some(function (_a) {
                    var id2 = _a.id;
                    return id1 === id2;
                });
            });
            if (nearestRightBrother) {
                _this.chatroomSelectHandler(nearestRightBrother.id);
            }
            return _this.chatroomSelectHandler(chatrooms[Math.min(chatrooms.length - 1, chatroomIndex)].id);
        };
        return _this;
    }
    ChatroomList.prototype.componentDidMount = function () {
        var _a = this.props, chatrooms = _a.chatrooms, onChatroomListChange = _a.onChatroomListChange, isFetchingChatrooms = _a.isFetchingChatrooms;
        onChatroomListChange === null || onChatroomListChange === void 0 ? void 0 : onChatroomListChange({ chatrooms: chatrooms, isFetchingChatrooms: isFetchingChatrooms });
    };
    ChatroomList.prototype.componentDidUpdate = function (prevProps) {
        var prevChatrooms = prevProps.chatrooms, prevIsFetchingChatrooms = prevProps.isFetchingChatrooms;
        var _a = this.props, chatrooms = _a.chatrooms, isFetchingChatrooms = _a.isFetchingChatrooms, selectedChatroomId = _a.selectedChatroomId, onChatroomListChange = _a.onChatroomListChange, shouldAutoSelectChatroom = _a.shouldAutoSelectChatroom;
        var didRoomsChanged = prevChatrooms !== chatrooms;
        var didFetchingStatusChanged = prevIsFetchingChatrooms !== isFetchingChatrooms;
        if (didRoomsChanged || didFetchingStatusChanged) {
            onChatroomListChange === null || onChatroomListChange === void 0 ? void 0 : onChatroomListChange({ chatrooms: chatrooms, isFetchingChatrooms: isFetchingChatrooms });
        }
        if (_isEmpty(chatrooms)) {
            return;
        }
        if (!selectedChatroomId) {
            if (!shouldAutoSelectChatroom || (shouldAutoSelectChatroom === null || shouldAutoSelectChatroom === void 0 ? void 0 : shouldAutoSelectChatroom(chatrooms[0]))) {
                this.selectFirstRoom();
            }
        }
        else if (didRoomsChanged) {
            this.selectRoomIfNeeded(prevChatrooms);
        }
    };
    ChatroomList.prototype.render = function () {
        var _this = this;
        var _a = this.props, emptyState = _a.emptyState, chatrooms = _a.chatrooms, isFirstLoading = _a.isFirstLoading, quickActionsStrategy = _a.quickActionsStrategy, getChatroomBadgeClassName = _a.getChatroomBadgeClassName, getChatroomBadgeIconComponent = _a.getChatroomBadgeIconComponent, appMode = _a.appMode, onChatroomNameClickCallback = _a.onChatroomNameClickCallback, locale = _a.locale, editMode = _a.editMode, _b = _a.checkedChatrooms, checkedChatrooms = _b === void 0 ? [] : _b, labelsList = _a.labelsList, hasError = _a.hasError, error = _a.error, errorState = _a.errorState, getErrorStateComponent = _a.getErrorStateComponent, eventHooks = _a.eventHooks;
        var errorStateComponent = getErrorStateComponent
            ? getErrorStateComponent(error)
            : errorState; //todo this.state.error can be null - need to deal with that in the client
        if (hasError && errorStateComponent) {
            return errorStateComponent;
        }
        return (React.createElement(I18nextProvider, { i18n: i18n({ locale: locale }) },
            React.createElement(AppModeProvider, { appMode: appMode }, isFirstLoading ? (React.createElement("div", { "data-hook": "chatroom-list", className: style.chatroomList },
                React.createElement(AnimatedPlaceholderChatroomList, null))) : chatrooms && chatrooms.length ? (React.createElement("div", { "data-hook": "chatroom-list", className: style.chatroomList }, chatrooms.map(function (room) { return (React.createElement(ChatroomListEntry, { labelsList: labelsList, selected: room.id === _this.props.selectedChatroomId, checked: checkedChatrooms.includes(room.id), key: room.id, room: room, onClick: _this.chatroomClickHandler, onCheckboxClick: _this.chatroomCheckHandler, onChatroomNameClickCallback: onChatroomNameClickCallback, quickActionsStrategy: quickActionsStrategy, getChatroomBadgeClassName: getChatroomBadgeClassName, getChatroomBadgeIconComponent: getChatroomBadgeIconComponent, editMode: editMode, eventHooks: eventHooks })); }))) : (emptyState))));
    };
    ChatroomList.isActive = function () { return !document.hidden; };
    return ChatroomList;
}(React.Component));
export default withChatrooms(withSounds({
    isChatActivePredicate: ChatroomList.isActive,
})(ChatroomList));
//# sourceMappingURL=ChatroomList.js.map